<template>
  <v-container id="details-container">
    <Title title="Learner Details"></Title>
    <h2 class="py-5 page-title" style="display: inline-block">
      Learner Details
    </h2>
    <BulkUploader :type="'learner'" style="float: right" />

    <v-stepper v-model="e6" vertical>
      <v-stepper-step color="#6490f1" :complete="e6 > 1" step="1" editable
        >Learner Background</v-stepper-step
      >

      <v-stepper-content step="1">
        <v-form ref="backgroundForm">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                ref="firstInput"
                v-model="firstName"
                label="First Name *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="middleName"
                label="Middle Name (Optional)"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="lastName"
                label="Last Name *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="email"
                label="Email Address  *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="dobMenu"
                v-model="dobMenu"
                :close-on-content-click="false"
                :return-value.sync="dateOfBirth"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateOfBirth"
                    label="Date of Birth *"
                    readonly
                    :rules="emptyRule"
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateOfBirth"
                  no-title
                  scrollable
                  @input="$refs.dobMenu.save(dateOfBirth)"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
        <v-btn tile color="#6490f1" dark @click="onSubmitBackground()"
          >Continue</v-btn
        >
        <div class="mb-5"></div>
      </v-stepper-content>

      <v-stepper-step color="#6490f1" :complete="e6 > 2" step="2"
        >Learner Info</v-stepper-step
      >
      <v-stepper-content step="2">
        <v-form ref="detailsForm">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="code"
                label="Learner Code (Auto-Generated)"
                class="my-3"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="centre"
                :items="centres"
                label="Centre *"
                :rules="emptyRule"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="learnerQualifications"
                :items="qualifications"
                :label="modifiedQualificationLabel"
                :rules="[required]"
                multiple
                class="my-3"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                ref="firstApprovedDateMenu"
                v-model="firstApprovedDateMenu"
                :close-on-content-click="false"
                :return-value.sync="firstApprovedDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="firstApprovedDate"
                    label="Registration Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="firstApprovedDate"
                  no-title
                  scrollable
                  @input="
                    $refs.firstApprovedDateMenu.save(firstApprovedDate);
                    onSelectRegistrationDate();
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                ref="renewalDateMenu"
                v-model="renewalDateMenu"
                :close-on-content-click="false"
                :return-value.sync="renewalDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="renewalDate"
                    label="Expiry Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="renewalDate"
                  no-title
                  scrollable
                  @input="$refs.renewalDateMenu.save(renewalDate)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="ukprn"
                label="UKPRN / Trainer Number"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="uln"
                label="Unique Learner Number"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="title"
                :items="titles"
                label="Title"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="nationality"
                :items="nationalities"
                label="Nationality"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="ethnicity"
                :items="ethnicities"
                label="Ethinicity"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="phoneNo"
                label="Phone Number"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mobileNo"
                label="Mobile Number "
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="addressLine1"
                label="Address Line 1"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="addressLine2"
                label="Address Line 2"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="addressLine3"
                label="Address Line 3"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="city"
                label="City  *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="postCode"
                label="Post Code  *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="country"
                :items="countries"
                label="Country *"
                :rules="emptyRule"
                class="my-3"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-btn tile color="#6490f1" dark @click="onReviewSummary()"
          >Review Summary</v-btn
        >
        <div class="mb-5"></div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import BulkUploader from "../components/BulkUploader";
import Title from "../components/Title";

export default {
  mounted: async function () {
    this.getCentres();
    this.getEthnicities();
    this.getNationalities();
    this.getCountries();
    await this.getQualifications();
    this.getLearner();
    this.getLearners();

    this.$refs.firstInput.focus();
  },
  components: {
    BulkUploader,
    Title,
  },
  data() {
    return {
      learnerQualifications: [],
      e6: 1,
      code: null,
      title: null,
      centre: null,
      qualification: null,
      firstApprovedDate: null,
      renewalDate: null,
      ukprn: null,
      firstName: null,
      middleName: null,
      lastName: null,
      uln: null,
      dateOfBirth: null,
      ethnicity: null,
      nationality: null,
      phoneNo: null,
      mobileNo: null,
      email: null,
      addressLine1: null,
      addressLine2: null,
      addressLine3: null,
      city: null,
      postCode: null,
      country: null,
      titles: ["Mr", "Mrs", "Ms", "Miss", "Prefer not to say"],
      centres: [],
      ethnicities: [],
      nationalities: [],
      qualifications: [],
      countries: [],
      firstApprovedDateMenu: false,
      renewalDateMenu: false,
      dobMenu: false,
      emptyRule: [(v) => !!v || "This field is required"],
      required: (value) => {
        if (value instanceof Array && value.length == 0) {
          return "This field is required.";
        }
        return !!value || "This field is required.";
      },
      qualificationCodeAndId: [],
      learners: [],
      qualificationLabel: "Qualifications",
    };
  },
  computed: {
    modifiedQualificationLabel: function () {
      if (this.$store.state.role == "centre") {
        return "Qualifications / Courses *";
      }

      return this.qualificationLabel;
    },
  },
  methods: {
    learnerItem: function () {
      return {
        code: this.code,
        title: this.title,
        centre: this.centre,
        qualification: this.learnerQualifications,
        firstApprovedDate: this.firstApprovedDate,
        renewalDate: this.renewalDate,
        ukprn: this.ukprn,
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        uln: this.uln,
        dateOfBirth: this.dateOfBirth,
        ethnicity: this.ethnicity,
        nationality: this.nationality,
        phoneNo: this.phoneNo,
        mobileNo: this.mobileNo,
        email: this.email,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        addressLine3: this.addressLine3,
        city: this.city,
        postCode: this.postCode,
        country: this.country,
      };
    },
    getLearnerQualifications: async function (learnerCode) {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/learners/code/${learnerCode}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      );

      const data = await response.json();

      return data.learners.map((learner) => learner.qualification._id);
    },
    writeToForm: async function (item) {
      item.qualifications = await this.getLearnerQualifications(item.code);

      this.code = item.code;
      this.learnerQualifications = this.mapQualificationsIdToCode(
        item.qualifications
      );
      this.title = item.title == "" ? "Prefer not to say" : item.title;
      this.firstApprovedDate = item.firstApprovedDate;
      this.renewalDate = item.renewalDate;
      this.ukprn = item.ukprn;
      this.firstName = item.firstName;
      this.middleName = item.middleName;
      this.lastName = item.lastName;
      this.uln = item.uln;
      this.dateOfBirth = item.dateOfBirth;
      this.ethnicity = item.ethnicity;
      this.nationality = item.nationality;
      this.phoneNo = item.phoneNo;
      this.mobileNo = item.mobileNo;
      this.email = item.email;
      this.addressLine1 = item.addressLine1;
      this.addressLine2 = item.addressLine2;
      this.addressLine3 = item.addressLine3;
      this.city = item.city;
      this.postCode = item.postCode;
      this.country = item.country;
    },
    mapQualificationsIdToCode: function (qualificationIds) {
      const learnerQualifications = [];

      for (let i = 0; i < qualificationIds.length; i++) {
        for (let j = 0; j < this.qualificationCodeAndId.length; j++) {
          if (qualificationIds[i] == this.qualificationCodeAndId[j].id) {
            learnerQualifications.push(this.qualificationCodeAndId[j].code);
          }
        }
      }

      return learnerQualifications;
    },
    getLearner: function () {
      if (this.$route.params.item) {
        // edit new learner
        this.writeToForm(this.$route.params.item);
      } else if (this.$route.query.id) {
        // edit exisiting learner
        fetch(
          `${process.env.VUE_APP_ROOT_API}/learners/${this.$route.query.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            this.writeToForm(data.learner);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    getLearners: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/learners?require=all`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.learners = data.learners;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCentres: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/centres`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.centres = data.centres.map((centre) => centre.name);

          for (let i = 0; i < data.centres.length; i++) {
            if (data.centres[i].learners.includes(this.$route.query.id)) {
              this.centre = data.centres[i].name;
              break;
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getEthnicities: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/ethnicities`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.ethnicities = data.ethnicities.map(
            (ethnicity) => ethnicity.name
          );

          this.ethnicities.unshift("Not supplied");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getNationalities: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/nationalities`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.nationalities = data.nationalities.map(
            (nationality) => nationality.name
          );

          this.nationalities.unshift("Not supplied");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getQualifications: function () {
      const promise = fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.qualifications = data.qualifications.map(
            (qualification) => qualification.code
          );

          this.qualificationCodeAndId = data.qualifications.map(
            (qualification) => {
              return { code: qualification.code, id: qualification._id };
            }
          );
        })
        .catch((error) => {
          console.error(error);
        });

      return promise;
    },
    getCountries: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/countries`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.countries = data.countries.map((country) => country.name);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onSubmitBackground() {
      if (!this.$refs.backgroundForm.validate()) {
        return;
      }

      this.e6 = 2;
    },
    onReviewSummary() {
      if (!this.$refs.detailsForm.validate()) {
        return;
      }

      if (this.$route.query.id) {
        this.$router.push({
          name: "Summary",
          params: { section: "learners", item: this.learnerItem() },
          query: { id: this.$route.query.id },
        });
      } else {
        this.$router.push({
          name: "Summary",
          params: { section: "learners", item: this.learnerItem() },
        });
      }
    },
    onSelectRegistrationDate: function () {
      const firstApprovedDate = this.firstApprovedDate.split("-");
      const renewalDate = `${Number(firstApprovedDate[0]) + 2}-${
        firstApprovedDate[1]
      }-${firstApprovedDate[2]}`;

      this.renewalDate = renewalDate;
    },
  },
};
</script>

<style scoped>
* {
  padding-top: 0;
  padding-bottom: 0;
}

#details-container {
  min-height: 100vh;
}
</style>